import { END, buffers, eventChannel } from "redux-saga";
import {
    all, call, cancelled, put, select, take, takeEvery
} from "redux-saga/effects";

import { ENDTIMER, FULLTIMER, defaultScopeId } from "./performanceLogs.duck";
import { logToAzure } from "./performanceLogs.api";

export const getcurrentMesureTime = (state, name) => {
    return {
        timers: state[defaultScopeId]?.timers,
        currentMesureTime: state[defaultScopeId]?.timers?.[name]
    }
};

function* sendEndTraceToAzure({ data: { name, time, item } }) {
    const { timers, currentMesureTime } = yield select(getcurrentMesureTime, `${name}-${item || ""}`);

    // Skip logging if currentMesureTime or start time is missing
    if (Object.keys(timers).length > 0 && (!currentMesureTime || !currentMesureTime.start)) {
        // Originally used: Promise.reject(...) to signal error, but that has no effect inside a generator and creates an unhandled rejection.
        // Promise.reject(new Error("Error occurs when selecting current time in performance saga"));
        return;
    }
    
    if(currentMesureTime){
        const end = time;
        yield call(logToAzure, { name, duration: (end - currentMesureTime.start), item });
    }
}

function* sendFullTimerTraceToAzure({ data: { name, start, end, item } }) {
    yield call(logToAzure, { name, duration: (end - start), item });
}

export default () => function* rootSaga() {
    yield takeEvery(ENDTIMER, sendEndTraceToAzure);
    yield takeEvery(FULLTIMER, sendFullTimerTraceToAzure);
};
